import { get, remove, set } from 'js-cookie';
export const COOKIE = 'tfoCustomerPortal';
export const BACKOFFICE_COOKIE = 'tfoBackOffice';
export function setCookie(value, key = COOKIE) {
    deleteCookie(key); // Remove any existing cookie with the same key
    sessionStorage.setItem(key, value);
    set(key, value, { path: '/', secure: true, sameSite: 'strict' });
}
export function deleteCookie(key = COOKIE) {
    sessionStorage.removeItem(key);
    remove(key);
}
export function parseCookie(key = COOKIE) {
    return sessionStorage.getItem(key) || get(key);
}
export function getCookie(key = COOKIE) {
    const rawCookieText = parseCookie(key);
    try {
        return rawCookieText ? JSON.parse(rawCookieText) : {};
    }
    catch (error) {
        // Our cookie has been tampered or is corrupted
        console.error({ error });
        deleteCookie(key);
        return {};
    }
}
export function getExpirationFromCookie(authCookie) {
    if (Object.entries(authCookie).length === 0) {
        return null;
    }
    try {
        const parsedCookie = authCookie.token
            .split('.')[1]
            .replace('-', '+')
            .replace('_', '/');
        const { exp } = JSON.parse(window.atob(parsedCookie));
        return new Date(exp * 1000);
    }
    catch (e) {
        console.error('Invalid cookie value', e);
        return new Date(null);
    }
}
export function loggedIn(key = COOKIE) {
    const cookie = getCookie(key);
    if (cookie) {
        var jwtExpiration = getExpirationFromCookie(cookie);
        if (jwtExpiration === null) {
            deleteCookie(key);
            return false;
        }
        var now = new Date();
        //ok status
        if (jwtExpiration.getTime() > now.getTime()) {
            setCookie(JSON.stringify(cookie));
            return true;
        }
        else {
            deleteCookie(key);
            return false;
        }
    }
    else {
        return false;
    }
}
export function needToChangePassword(key = COOKIE) {
    const cookie = getCookie(key);
    if (cookie) {
        return cookie.needToChangePasswordOnNextLogin;
    }
}
export function updateNeedToChangePassword(key = COOKIE) {
    const cookie = getCookie(key);
    if (cookie) {
        cookie.needToChangePasswordOnNextLogin = false;
        setCookie(JSON.stringify(cookie));
    }
}
export function updateAcceptedGeneralTermsTimeStamp(timeStamp, key = COOKIE) {
    const cookie = getCookie(key);
    if (cookie) {
        cookie.acceptedGeneralTerms = timeStamp;
        setCookie(JSON.stringify(cookie));
    }
}
